/**
 * Trading API
 * OpenAPI documentation for the Trading API (with login, logout, hello endpoints).
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";

/**
* Trading service.
* @module api/TradingApi
* @version 1.0
*/
export default class TradingApi {

    /**
    * Constructs a new TradingApi. 
    * @alias module:api/TradingApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }



    /**
     * Simple GET endpoint that takes a 'text' query parameter
     * Returns the input text along with the current logged-in username. and returns it along with the user's username (session-based).
     * @param {Object} opts Optional parameters
     * @param {String} [text] Input text from user (as a query parameter).
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */
    getHelloResourceWithHttpInfo(opts) {
      opts = opts || {};
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
        'text': opts['text']
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = [];
      let returnType = null;
      return this.apiClient.callApi(
        '/trading/hello', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null
      );
    }

    /**
     * Simple GET endpoint that takes a 'text' query parameter
     * Returns the input text along with the current logged-in username. and returns it along with the user's username (session-based).
     * @param {Object} opts Optional parameters
     * @param {String} opts.text Input text from user (as a query parameter).
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */
    getHelloResource(opts) {
      return this.getHelloResourceWithHttpInfo(opts)
        .then(function(response_and_data) {
          return response_and_data.data;
        });
    }


}
